import * as Mutations from "./mutation-types"
import * as Actions from "./action-types"
import * as api from "@/api/api"
import * as Helpers from "@/helpers"

const state = {
    overviewInitStatus: "NOT_LOADED",
    overviewPublishedDate: null,
    topProgramsLatestDayResults: {
        status: "NOT LOADED",
    },
    topProgramsSevenDaysResults: {
        status: "NOT LOADED",
    },
    sitesReachSevenDaysResults: {
        status: "NOT LOADED",
    },
}

const processTopProgramsQuery = async (context, r, visibleResultsCount, mutationType) => {
    const columns = ["date", "time", "providerName", "title", "episode", "seasonNumber", "titleCode"]
    try {
        if (r.programs.length == 0) {
            context.commit(Mutations[mutationType], {
                status: "EMPTY_RESULT",
            })
        } else {
            let levelOneProgramsWithLevelTwoPrograms = r.programs
                .filter(p => p.contentGroupTotal && !p.isTotal)
                .map((p, i) => {
                    for (let i = 0; i < p.measures.length; i++) {
                        p[`measure_${i + 1}`] = p.measures[i]
                    }
                    let levelTwoPrograms = r.programs
                        .filter(lv2p => lv2p.groupKey === p.groupKey && !lv2p.contentGroupTotal)
                        .map(p => {
                            for (let i = 0; i < p.measures.length; i++) {
                                p[`measure_${i + 1}`] = p.measures[i]
                            }
                            return {
                                ...p,
                                chosen: false,
                            }
                        })
                    Helpers.setLevelOneValuesForPrograms(p, levelTwoPrograms, columns)
                    return {
                        ...p,
                        levelTwoPrograms: levelTwoPrograms,
                        index: i,
                        chosen: false,
                    }
                })
            let fields = context.getters.getProgramsColumnTypes
                .filter(c => columns.includes(c.value))
                .map(c => {
                    return {
                        key: c.value,
                        label: c.text,
                    }
                })
            let fieldsMeasures = []
            for (let i = 0; i < r.measureHeaders.length; i++) {
                fieldsMeasures.push({
                    key: `measure_${i + 1}`,
                    label: `${r.measureHeaders[i].header} ${r.measureHeaders[i].subHeader}`,
                    header: r.measureHeaders[i].header,
                    subHeader: r.measureHeaders[i].subHeader,
                    tdClass: "measureTdClass",
                    thClass: "measurethclass",
                })
            }
            // keep top ten only
            levelOneProgramsWithLevelTwoPrograms.length = visibleResultsCount
            context.commit(Mutations[mutationType], {
                status: "LOADED",
                data: { levelOneProgramsWithLevelTwoPrograms: levelOneProgramsWithLevelTwoPrograms, columns: [...fields, ...fieldsMeasures] },
            })
        }
    } catch (error) {
        context.commit(Mutations[mutationType], {
            status: "FAILED",
            data: null,
            error: error,
        })
    }
}

const processSitesReachSevenDaysQuery = async (context, r) => {
    try {
        context.commit(Mutations.setSitesReachSevenDaysResults, {
            status: "LOADING",
            data: null,
        })
        let columns = context.getters.getChannelsColumnTypes
        if (r.sites.length == 0) {
            context.commit(Mutations.setSitesReachSevenDaysResults, {
                status: "EMPTY_RESULT",
            })
        } else {
            let levelOneSitesWithLevelTwoSites = r.sites
                .filter(s => s.isParent)
                .map((s, i) => {
                    for (let i = 0; i < s.measures.length; i++) {
                        s[`measure_${i + 1}`] = s.measures[i]
                    }
                    let levelTwoSites = r.sites
                        .filter(lv2p => lv2p.siteName === s.siteName && !lv2p.isParent && lv2p.date === s.date)
                        .map(s => {
                            for (let i = 0; i < s.measures.length; i++) {
                                s[`measure_${i + 1}`] = s.measures[i]
                            }
                            return {
                                ...s,
                                chosen: false,
                            }
                        })
                    Helpers.setLevelOneValuesForChannels(s, levelTwoSites)
                    return {
                        ...s,
                        levelTwoSites: levelTwoSites,
                        index: i,
                        chosen: false,
                    }
                })
            let fields = context.getters.getChannelsColumnTypes
                .filter(c => columns.includes(c.value))
                .map(c => {
                    return {
                        key: c.value,
                        label: c.text,
                        sortable: true,
                    }
                })
            for (const field of fields) {
                if (field.key === "date") {
                    field.thClass = "date-th"
                }
            }
            let fieldsMeasures = []
            for (let i = 0; i < r.measureHeaders.length; i++) {
                fieldsMeasures.push({
                    key: `measure_${i + 1}`,
                    label: `${r.measureHeaders[i].header} ${r.measureHeaders[i].subHeader}`,
                    header: r.measureHeaders[i].header,
                    subHeader: r.measureHeaders[i].subHeader,
                    sortable: true,
                    tdClass: "measureTdClass",
                })
            }
            context.commit(Mutations.setSitesReachSevenDaysResults, {
                status: "LOADED",
                data: {
                    levelOneSitesWithLevelTwoSites: levelOneSitesWithLevelTwoSites,
                    columns: [...fields, ...fieldsMeasures],
                },
            })
        }
    } catch (error) {
        context.commit(Mutations.setSitesReachSevenDaysResults, {
            status: "FAILED",
            data: null,
            error: error,
        })
    }
}

const actions = {
                // update state overviewInitStatus to notify when the page has fetched all data
    [Actions.executeOverviewPublishedDateQuery]: async context => {
        // initiera/resetta selected rows
        let result
        try {
            result = await api.getOverviewPublishedDate()
        } catch (error) {
            context.commit(Mutations.setOverviewPublishedDate, null)
        }
        context.commit(Mutations.setOverviewPublishedDate, result)
    },
    [Actions.executeTopProgramsLatestDayQuery]: async context => {
        // initiera/resetta selected rows
        let result
        try {
            result = await api.getTopProgramsLatestDay()
        } catch (error) {
            context.commit(Mutations.setTopProgramsLatestDayResults, {
                status: "FAILED",
                data: null,
                error: error,
            })
        }
        await processTopProgramsQuery(context, result, 10, "setTopProgramsLatestDayResults")
    },
    [Actions.executeTopProgramsSevenDaysQuery]: async context => {
        // initiera/resetta selected rows
        let result
        try {
            result = await api.getTopProgramsSevenDays()
        } catch (error) {
            context.commit(Mutations.setTopProgramsSevenDaysResults, {
                status: "FAILED",
                data: null,
                error: error,
            })
        }
        await processTopProgramsQuery(context, result, 10, "setTopProgramsSevenDaysResults")
    },
    [Actions.executeSitesReachSevenDaysQuery]: async context => {
        // initiera/resetta selected rows
        let result
        try {
            result = await api.getSitesReachSevenDays()
        } catch (error) {
            context.commit(Mutations.setSitesReachSevenDaysResults, {
                status: "FAILED",
                data: null,
                error: error,
            })
        }
        await processSitesReachSevenDaysQuery(context, result)
    },
}

const getters = {
    getOverviewInitStatus: state => state.overviewInitStatus,
    getOverviewPublishedDate: state => state.overviewPublishedDate,
    getTopProgramsLatestDayResults: state => state.topProgramsLatestDayResults,
    getTopProgramsSevenDaysResults: state => state.topProgramsSevenDaysResults,
    getSitesReachSevenDaysResults: state => state.sitesReachSevenDaysResults,
}

const mutations = {
    [Mutations.setOverviewInitStatus]: (state, payload) => (state.overviewInitStatus = payload),
    [Mutations.setOverviewPublishedDate]: (state, payload) => (state.overviewPublishedDate = payload),
    [Mutations.setTopProgramsLatestDayResults]: (state, payload) => (state.topProgramsLatestDayResults = payload),
    [Mutations.setTopProgramsSevenDaysResults]: (state, payload) => (state.topProgramsSevenDaysResults = payload),
    [Mutations.setSitesReachSevenDaysResults]: (state, payload) => (state.sitesReachSevenDaysResults = payload),
}

export default {
    state,
    getters,
    mutations,
    actions,
}
